/**
 * Whether a course is ZPP-certified, based on its current/old ZPP id validity window.
 * Mirrored in physiofit_cloud_functions (`utils/courseCertification/courseCertificationWindow.ts`,
 * `isCourseCertifiedAt`, which `invitePatient.ts` calls with the current date). Keep in sync.
 */
import type { Course } from '@physiofit-digital/physiofit_types';

export function isCourseCertified(
  course: Pick<Course, 'zppName' | 'zppId' | 'zppIdStartDate' | 'zppIdOldEndDate'>,
): boolean {
  if (!course.zppName || !course.zppId) {
    return false;
  }
  const now = new Date();
  const oldIdEndDate = course.zppIdOldEndDate ? new Date(course.zppIdOldEndDate) : undefined;
  const newIdStartDate = course.zppIdStartDate ? new Date(course.zppIdStartDate) : undefined;
  if (oldIdEndDate && now < oldIdEndDate) {
    return true;
  }
  if (newIdStartDate && now > newIdStartDate) {
    return true;
  }
  return false;
}
